import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfGaleriaImagensSchema } from './schema';

/**
 * Formulário da barra lateral. Sob `withObjectBrowser` porque o campo Imagem de
 * cada foto abre o navegador de conteúdo de dentro de um `object_list`.
 *
 * Sem `dataAdapter` próprio (não há autofill: cada foto é escolhida à mão),
 * então o `onChangeField` cai no gravar direto — o mesmo fallback que os demais
 * blocos usam quando o registro não declara um.
 */
const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfGaleriaImagensSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) =>
        dataAdapter({ block, data, id, onChangeBlock, value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
